import { useState } from "react";
import { atualizarPeriodoService } from "../../../services/atualizarPeriodoService";
import { verificarPeriodoService } from "../../../services/verificarPeriodoService";

export const useAtualizarPeriodo = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<string | null>(null);
  const resetError = () => setError(null); // Função para resetar o erro

  const atualizar = async (
    valuesMaisPeriodo: any,
    cotaId: number,
    periodoId: number
  ) => {
    setIsLoading(true);
    const periodoData = {
      checkIn: valuesMaisPeriodo.checkIn,
      checkOut: valuesMaisPeriodo.checkOut,
      dataEspecial: valuesMaisPeriodo.dataEspecial,
      valor: valuesMaisPeriodo.valor,
      cotaId: cotaId,
      origem: 0,
    };

    try {
      const checagemPeriodo = await verificarPeriodoService(periodoId);

      if (checagemPeriodo.length === 0) {
        const periodo = await atualizarPeriodoService(periodoId, periodoData);
        if (periodo) {
          setSuccess("Período atualizado com sucesso!");
        }
      } else {
        setError(
          "Alguns usuários já estão usando esse período. Por isso não é possível editar as datas. Só a data especial e valor."
        );
      }
    } catch (error) {
      setError("Não foi possível atualizado periodo, tente novamente!");
    } finally {
      setIsLoading(false);
    }
  };

  return { atualizar, isLoading, error, success, resetError };
};
